import store from '@/store'

export default class Score {
  constructor (data) {
    this.id = data.id
    this.competitorId = data.competitorId
    this.competitorPersonId = data.competitorPersonId
    this.statusId = data.statusId
    this.typeId = data.typeId
    this.score = data.score
    this.order = data.order
  }

  getType () { return store.getters['Sport/ScoreType/get'](this.typeId) }
}
